import styled from 'styled-components';

import { ReactElement } from 'react';
import { Colors } from '../types';

export const StyledHeader = styled.header<{left?: ReactElement;
    right?: ReactElement;
    $fixed?: boolean;
    $withShadow?: boolean;
    $backgroundColor?: Colors;
    className?: string;}>`
    padding: 0 12px;
    height: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1000;
    ${({ $fixed = false }) =>
        $fixed &&
        `
        width: 100%;
        position: fixed;
        top: 0;
    `};
    ${({ $withShadow }) => $withShadow && 'box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);'};
    ${({ theme, $backgroundColor }) => $backgroundColor && `background-color: ${theme[$backgroundColor]}`};
`;

export const StyledChildBlock = styled.div`
    width: 100%;
    max-width: calc(50% - 4px);
    &:last-child {
        display: flex;
        justify-content: flex-end;
    }
`;
